(function (root) {
  'use strict';
  const normalize = value => String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();
  function selectProducts(products, state = {}) {
    const terms = normalize(state.query).split(' ').filter(Boolean);
    const result = products.filter(product => {
      const haystack = normalize([product.title, product.sku, product.family, product.searchText].join(' '));
      return (!state.range || (product.ranges || []).includes(state.range)) &&
        (!state.family || product.family === state.family) && terms.every(term => haystack.includes(term));
    });
    if (state.sort === 'price-asc') result.sort((a, b) => a.price - b.price || a.title.localeCompare(b.title));
    if (state.sort === 'price-desc') result.sort((a, b) => b.price - a.price || a.title.localeCompare(b.title));
    if (state.sort === 'name') result.sort((a, b) => a.title.localeCompare(b.title));
    return result;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { selectProducts };
  if (typeof document === 'undefined') return;
  const shell = document.querySelector('[data-mamba-catalog]');
  if (!shell) return;
  const grid = shell.querySelector('[data-mamba-grid]');
  const form = shell.querySelector('[data-mamba-filters]');
  const count = shell.querySelector('[data-mamba-count]');
  const more = shell.querySelector('[data-mamba-more]');
  const empty = shell.querySelector('[data-mamba-empty]');
  const rangeButtons = Array.from(shell.querySelectorAll('[data-mamba-range]'));
  rangeButtons.filter(node => node.tagName === 'A').forEach(node => node.addEventListener('keydown', event => { if (event.key === ' ') { event.preventDefault(); node.click(); } }));
  const state = { range: '', family: '', query: '', sort: '', limit: 24 };
  let products = [];
  const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  const rangeNames = { universal: 'Universal ball-bearing', vw: 'Volkswagen / Audi', bmw: 'BMW', 'sema-2026': 'SEMA 2026' };
  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }
  function card(product) {
    const article = element('article', 'mamba-product-card');
    const link = element('a', 'mamba-product-card__photo');
    link.href = '/products/' + encodeURIComponent(product.handle);
    link.setAttribute('aria-label', product.title);
    if (product.image) {
      const img = element('img');
      img.src = product.image; img.alt = product.title; img.width = 600; img.height = 600;
      img.loading = 'lazy'; img.decoding = 'async';
      link.append(img);
    }
    article.append(link);
    const meta = element('div', 'mamba-product-card__meta');
    const heading = element('h3');
    const titleLink = element('a', '', product.displayTitle || product.title);
    titleLink.href = link.href; titleLink.title = product.title; heading.append(titleLink); meta.append(heading);
    meta.append(element('p', 'mamba-product-card__detail', product.detail || product.title));
    const bottom = element('div', 'mamba-product-card__bottom');
    bottom.append(element('p', 'mamba-product-card__price', money.format(product.price)));
    const view = element('a', 'mamba-product-card__view', 'View turbo'); view.href = link.href;
    bottom.append(view); meta.append(bottom); article.append(meta);
    return article;
  }
  function render() {
    const results = selectProducts(products, state);
    grid.replaceChildren(...results.slice(0, state.limit).map(card));
    count.textContent = `${results.length} ${results.length === 1 ? 'turbo' : 'turbos'}${state.range ? ' · ' + rangeNames[state.range] : ''}`;
    more.hidden = results.length <= state.limit;
    more.textContent = `Show ${Math.min(24, Math.max(0, results.length - state.limit))} more`;
    empty.hidden = results.length !== 0;
    rangeButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mambaRange === state.range)));
  }
  rangeButtons.forEach(button => button.addEventListener('click', event => {
    event.preventDefault();
    state.range = button.dataset.mambaRange; state.limit = 24;
    render();
    document.getElementById('mamba-range').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  }));
  form.addEventListener('submit', event => event.preventDefault());
  form.addEventListener('input', () => {
    state.query = form.elements.search.value;
    state.family = form.elements.family.value;
    state.sort = form.elements.sort.value;
    state.limit = 24; render();
  });
  shell.querySelector('[data-mamba-reset]').addEventListener('click', () => {
    form.reset(); Object.assign(state, { query: '', range: '', family: '', sort: '', limit: 24 }); render();
    form.elements.search.focus();
  });
  more.addEventListener('click', () => { state.limit += 24; render(); });
  fetch(shell.dataset.catalogUrl).then(response => {
    if (!response.ok) throw new Error('Catalog request failed');
    return response.json();
  }).then(data => {
    products = data.products;
    const families = [...new Set(products.map(p => p.family).filter(Boolean))].sort();
    families.forEach(family => { const option = element('option', '', family); option.value = family; form.elements.family.append(option); });
    form.hidden = false;
    shell.querySelector('[data-mamba-range-controls]').hidden = false;
    render();
  }).catch(() => {
    count.textContent = 'Browse the Mamba collection below.';
  });
  if (!matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('mamba-entered'); observer.unobserve(entry.target); }
    }), { threshold: 0.08 });
    shell.querySelectorAll('[data-mamba-reveal]').forEach(node => observer.observe(node));
  }
})(typeof window !== 'undefined' ? window : this);
